//Module Keys
let locales = {};

//Merge Views
import mainView from 'Modules/reports/views/main/lan/en';
locales = { ...locales, ...mainView };

import mainRTView from 'Modules/reports/views/main/components/reportsTab/lan/en';
locales = { ...locales, ...mainRTView };

import mainSTView from 'Modules/reports/views/main/components/scheduleTab/lan/en';
locales = { ...locales, ...mainSTView };

import modalExtraTime from 'Modules/reports/views/main/components/reportsTab/.components/modalExtraTime/lan/en';
locales = { ...locales, ...modalExtraTime };

import formFtp from 'Modules/reports/views/main/components/ftpForm/lan/en'
locales = { ...locales, ...formFtp };
import modalReportTypes from 'Modules/reports/views/main/components/reportsTab/.components/reportTypes/lan/en';
locales = { ...locales, ...modalReportTypes };



export default locales;